import { GlFormGroup, GlFormTextarea } from '@gitlab/ui';
import { translate } from '@gitlab/ui/dist/utils/i18n';
import GlDuoUserFeedback from '../../../user_feedback/user_feedback';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

const i18n = {
  TITLE: translate('DuoChatMessage.modalTitle', 'Give feedback on GitLab Duo Chat'),
  ALERT_TEXT: translate('DuoChatMessage.modalAlertText', 'GitLab team members cannot view your conversation. Please be as descriptive as possible.'),
  DID_WHAT: translate('DuoChatMessage.modalDidWhat', 'What were you doing?'),
  INTERACTION: translate('DuoChatMessage.modalInteraction', 'The situation in which you interacted with GitLab Duo Chat.'),
  IMPROVE_WHAT: translate('DuoChatMessage.modalImproveWhat', 'How could the response be improved?'),
  BETTER_RESPONSE: translate('DuoChatMessage.modalBetterResponse', 'How the response might better meet your needs.'),
  MESSAGE_ERROR: translate('DuoChatMessage.modalMessageError', 'Error sending the message')
};
var script = {
  i18n,
  name: 'MessageFeedback',
  components: {
    GlDuoUserFeedback,
    GlFormGroup,
    GlFormTextarea
  },
  provide() {
    return {
      modalTitle: i18n.TITLE,
      modalAlertText: i18n.ALERT_TEXT
    };
  },
  props: {
    hasFeedback: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      didWhat: '',
      improveWhat: ''
    };
  },
  methods: {
    logEvent(e) {
      this.$emit('feedback', {
        ...e,
        didWhat: this.didWhat,
        improveWhat: this.improveWhat
      });
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gl-duo-user-feedback',{attrs:{"feedback-received":_vm.hasFeedback,"modal-title":_vm.$options.i18n.TITLE,"modal-alert":_vm.$options.i18n.ALERT_TEXT},on:{"feedback":_vm.logEvent},scopedSlots:_vm._u([{key:"feedback-extra-fields",fn:function(){return [_c('gl-form-group',{attrs:{"label":_vm.$options.i18n.DID_WHAT,"optional":"","data-testid":"did-what-form-group"}},[_c('gl-form-textarea',{attrs:{"placeholder":_vm.$options.i18n.INTERACTION},model:{value:(_vm.didWhat),callback:function ($$v) {_vm.didWhat=$$v;},expression:"didWhat"}})],1),_vm._v(" "),_c('gl-form-group',{attrs:{"label":_vm.$options.i18n.IMPROVE_WHAT,"optional":"","data-testid":"improve-what-form-group"}},[_c('gl-form-textarea',{attrs:{"placeholder":_vm.$options.i18n.BETTER_RESPONSE},model:{value:(_vm.improveWhat),callback:function ($$v) {_vm.improveWhat=$$v;},expression:"improveWhat"}})],1)]},proxy:true}])})};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
export { i18n };
